// @TODO: <HEALTH2019>
// @TODO: Add ngFileUpload dependency
var App = angular
    .module("App", ["ui.router", "ngAnimate", "ngSanitize", "angularMoment", "ngMaterial", "ngMessages", "material.components.eventCalendar", "ngFileSaver", "base64", "ui.mask", "ngCookies", "angularMoment", "vcRecaptcha", "angular.filter", 'ngFileUpload', 'ui.validate'])
    .constant('_', window._);
// @TODO: </HEALTH2019>

App.run(['$rootScope', '$state', '$stateParams', '$timeout', 'dataUser', 'subscription', '$mdDialog', function ($rootScope, $state, $stateParams, $timeout, dataUser, subscription, $mdDialog) {

    // @TODO <HEALTH2019>
    $rootScope.CONFIGURATOR = angular.copy(CONFIGURATOR);
    // @TODO </HEALTH2019>

    $rootScope._ = window._;

    var date = new Date();
    $rootScope.__prevMonth = new Date(date.getFullYear(), date.getMonth() - 1, 21);
    // TODO-MZ clean up after 1st April 2022
    if ($rootScope.CONFIGURATOR.companyCodename === 'cargo' &&  new Date().getFullYear() === 2022 &&  new Date().getMonth() === 2) {
        $rootScope.__prevMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    }
    $rootScope.__thisMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    $rootScope.__min1968 = new Date('1968/1/1');
    $rootScope.__maxDate = new Date();


    function onRouteChangeStart(e, toState, toParams) {
        var reg = isLogged === undefined || isLogged === null || isLogged.length == 0;
        var isLogged = window.sessionStorage.getItem('isLogged');
        $rootScope.currentUser = JSON.parse(window.sessionStorage.getItem('userObject'));

        if (reg && toState) {
            if (
                toState.name.indexOf('root.dashboard') !== -1
                || toState.name.indexOf('root.login') !== -1
                || toState.name.indexOf('root.register') !== -1
                || toState.name.indexOf('root.remember') !== -1
                || toState.name === 'root.remind'
                || toState.name === 'root.completeRegistration'
                || toState.name === 'root.confirmRegistration'
                || toState.name === 'root.confirmRelativeRegistration'
                || toState.name === 'root.regulations'
                || toState.name === 'root.privacypolicy'
                || toState.name === 'root.health'
                || toState.name === 'root.life'
                || toState.name === 'root.contact'
                || toState.name === 'root.facilities'
                || toState.name === 'root.download') {
                return 0;
            } else {
                $state.go('root.dashboard');
            }
        } else {
            dataUser.refreshInfo();
        }

        if ($state.$current.self.url === '^' && toState) { // refresh page - change current state to same state
            $timeout(function () {
                $state.go(toState.name, JSON.parse(window.sessionStorage.getItem('params')));
            }, 0);
        } else if (toParams) {
            window.sessionStorage.setItem('params', JSON.stringify(toParams));
        }

        hideMenu();
        $mdDialog.cancel();
    }

    onRouteChangeStart();
    $rootScope.$on('$stateChangeStart', function (e, toState, toParams) {
        onRouteChangeStart(e, toState, toParams);
    });

    $rootScope.$on('$stateChangeSuccess', function (e, toState, toParams) {
        $rootScope.currentState = toState;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    $rootScope.$on('$viewContentLoaded', function (event) {
        $("input.md-datepicker-input").prop('readonly', true);
    });

}]);

function hideMenu() {
    var w = -$('.menu_mobile').innerWidth();

    $('.menu_mobile').removeClass('open');
    $('.menu_mobile').velocity("stop", true).velocity({right: w});
}

function calendarDecorator($delegate, $document) {
    var documentElement = $document[0];

    if ($delegate.length) {
        $delegate[0].controller.prototype.hideVerticalScrollbar = function () {
            var scrollMask = documentElement.querySelector(".md-calendar-scroll-mask");
            if (scrollMask) {
                var scrollMaskElement = angular.element(scrollMask);
                scrollMaskElement.removeClass("md-calendar-scroll-mask");
                scrollMaskElement.addClass("custom-calendar-scroll-mask");
            }
        };
    }

    return $delegate;
}

calendarDecorator.$inject = ["$delegate", "$document"];

App.config(['$provide', function ($provide) {
    $provide.decorator('mdCalendarDirective', calendarDecorator);
}]);

App.config(['$provide', function addReporting($provide) {

        // Provide an interceptor for the error workflow.
        $provide.decorator(
            "$exceptionHandler",
            ['$delegate', 'errors', function ($delegate, errors) {

                // Return the new $exceptionHandler implementation which will
                // report the error to our internal error handler before passing
                // it off to the original $exceptionHandler implementation (which
                // may, itself, be some other delegate provided by another part
                // of the application).
                return (
                    function exceptionHandlerProxy(error, cause) {

                        errors.report(error);

                        $delegate(error, cause);

                    }
                );

            }]
        );

    }
]);

App.factory("errors",['$window', '$log', function errorLoggerFactory($window, $log) {

        // Return the public API.
        return ({
            report: report
        });


        // I report errors to the remote server.
        function report(error) {

            // In this case, we're going to be using New Relic's Browser API to
            // report JavaScript errors that originate from within the AngularJS
            // application try / catch blocks (which is why the global error
            // handler doesn't see them). But, since New Relic is a per-server
            // cost, we might not have it enabled in every environment. Let's
            // check to see if the API exists before we try to use it.
            if ($window.NREUM && $window.NREUM.noticeError) {

                try {

                    $window.NREUM.noticeError(error);

                    // If logging errors is causing an error, just swallow those
                    // errors; attempting to log these errors might lock the browser
                    // in an infinite loop.
                } catch (newRelicError) {

                    $log.error(newRelicError);

                }

            } else {

                $log.info("New Relic not available to record error.");

            }

        }

    }
]);


// var ASSETS_DIR = 'Assets/';
// var IMAGES_DIR = 'Images/';
